import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AlertTriangle } from 'lucide-react';
import { App } from './App';
import './i18n';
import './index.css';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div className="flex items-center justify-center h-full p-4">
        <div className="max-w-sm mx-auto text-center p-6 rounded-lg border bg-card">
          <div className="w-14 h-14 rounded-2xl bg-muted/60 flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="h-7 w-7 text-muted-foreground/40" />
          </div>
          <h2 className="text-lg font-semibold mb-2">Κάτι πήγε στραβά</h2>
          <p className="text-sm text-muted-foreground mb-4">Παρουσιάστηκε ένα σφάλμα.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium"
          >
            Επαναφόρτωση
          </button>
        </div>
      </div>
    }>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
